import React from "react";

const Terms = () => {
  return (
    <div className="min-h-screen bg-white pt-24 pb-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8 text-gray-900">Terms and Conditions</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-8">Last Updated: December 2025</p>
          
          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-gray-900">1. Purpose of the Network</h2>
              <p>
                Our platform is designed to connect students with campus projects. By submitting your interest, you are requesting to receive project-specific information and collaboration opportunities.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-gray-900">2. Role Selection and Collaboration</h2>
              <p>
                Selection of a "Primary Area of Interest" via our skill cards is used for initial organization and onboarding. However, our projects are highly collaborative; you may have the opportunity to contribute across multiple roles regardless of your initial selection.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-gray-900">3. User Conduct</h2>
              <p>
                Users agree to provide accurate information and to use project materials (briefs, insights, and tools) solely for their intended academic and professional development purposes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-gray-900">4. Intellectual Property</h2>
              <p>
                All project briefs, industry insights, and materials provided during onboarding are the property of IMPACT. and its respective industry partners.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-gray-900">5. Limitation of Liability</h2>
              <p>
                Participation in these projects is voluntary. IMPACT is not liable for any outcomes or disputes arising from student-led collaborations or project executions.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;

